import { gql } from '@apollo/client';

const schedulerFlowFragment = gql`
  fragment SchedulerFlowFragment on SchedulerFlow {
    id
    name
  }
`;
export const SchedulerFlowExperimentsQuery = gql`
  ${schedulerFlowFragment}
  query SchedulerFlowExperiments($campaignShortId: ID!) {
    schedulerFlowExperiments(campaignShortId: $campaignShortId) {
      created
      deleted
      end
      hasMetrics
      id
      modified
      schedulerFlowAVolume
      schedulerFlowBVolume
      schedulerFlowCVolume
      schedulerFlowDVolume
      schedulerFlowAId
      schedulerFlowBId
      schedulerFlowCId
      schedulerFlowDId
      start
      schedulerFlowA {
        ...SchedulerFlowFragment
      }
      schedulerFlowB {
        ...SchedulerFlowFragment
      }
      schedulerFlowC {
        ...SchedulerFlowFragment
      }
      schedulerFlowD {
        ...SchedulerFlowFragment
      }
    }
  }
`;

export const SchedulerFlowsForExperimentsQuery = gql`
  query SchedulerFlowsForExperiments($companyId: ID!) {
    schedulerFlowsByCompanyId(companyId: $companyId) {
      id
      name
    }
  }
`;

export const SchedulerFlowExperimentMutation = gql`
  mutation UpdateSchedulerFlowExperiment($input: UpdateSchedulerFlowExperimentInput!) {
    updateSchedulerFlowExperiment(input: $input)
  }
`;

export const CreateSchedulerFlowExperimentMutation = gql`
  mutation CreateSchedulerFlowExperiment($input: CreateSchedulerFlowExperimentInput!) {
    createSchedulerFlowExperiment(input: $input)
  }
`;
